import { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

import Metrics from "./Metrics";
import Reports from "./Reports";
import Slide from "./Slider";
import Statistics from "./Statistics";
import { slideContainerStyles, wrapperStyles } from "./styles";

const slides = [
  { key: 1, Component: <Statistics /> },
  { key: 2, Component: <Metrics /> },
  { key: 3, Component: <Reports /> },
];

const VerticalCarousel = () => {
  const initialOffsetRadius = 2;
  const [index, setIndex] = useState(0);
  const stepperRef = useRef<HTMLElement>();
  const containerRef = useRef<HTMLElement>();

  const clampOffsetRadius = (offsetRadius: number) => {
    const upperBound = Math.floor((slides.length - 1) / 2);
    if (offsetRadius < 0) {
      return 0;
    }
    if (offsetRadius > upperBound) {
      return upperBound;
    }
    return offsetRadius;
  };

  const modBySlidesLength = (idx: number) => {
    const mod = ((idx % slides.length) + slides.length) % slides.length;
    return mod;
  };

  const getPresentableSlides = () => {
    let offsetRadius = initialOffsetRadius;
    offsetRadius = clampOffsetRadius(offsetRadius);

    const presentableSlides = [];
    for (let i = -offsetRadius; i < 1 + offsetRadius; i++) {
      presentableSlides.push(slides[modBySlidesLength(index + i)]);
    }
    return presentableSlides;
  };

  // Handling scroll events
  useEffect(() => {
    const handleScroll = () => {
      if (stepperRef.current && containerRef.current) {
        const value =
          stepperRef.current.offsetTop - containerRef.current.offsetTop;

        if (value >= 0 && value < 900) {
          const step = Math.floor(value / 300);
          setIndex(step);
        }
      }
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup function to remove scroll event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Box sx={{ height: "2000px" }} mx="auto" ref={containerRef}>
      <Box ref={stepperRef} sx={wrapperStyles}>
        <Box sx={slideContainerStyles}>
          {getPresentableSlides().map(({ key }, presentableIndex) => (
            <Slide
              key={key}
              offsetRadius={clampOffsetRadius(initialOffsetRadius)}
              index={presentableIndex}
              activeIndex={index}
            >
              {key === 1 && <Reports />}
              {key === 2 && <Statistics />}
              {key === 3 && <Metrics />}
            </Slide>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default VerticalCarousel;
